<template>
  <h1>auth</h1>
</template>